<template>
  <hover-popover class="inventory-hover-target" :class="{ 'inventory-hover-target--active': canOpen }" :disabled="!canOpen" popover-class="inventory-detail-tooltip" @show="emitOpen">
    <slot>
      <span>{{ value }}</span>
    </slot>
    <template #content>
      <div class="inventory-tooltip-content">
        <div v-if="isLoading" class="inventory-tooltip-empty">
          {{ $t("wms.inventoryOverviewTooltip.loading") }}
        </div>
        <div v-else-if="!rows.length" class="inventory-tooltip-empty">
          {{ $t("wms.inventoryOverviewTooltip.noData") }}
        </div>
        <div v-else-if="!isLoading" class="inventory-tooltip-body">
          <table class="inventory-tooltip-table">
            <thead>
              <tr>
                <th>{{ $t("wms.inventoryOverviewTooltip.shortLocation") }}</th>
                <th>{{ $t("wms.inventoryOverviewTooltip.shortDate") }}</th>
                <th>{{ $t("wms.inventoryOverviewTooltip.shortInventory") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rows" :key="row.key">
                <td>{{ row.storageLocation }}</td>
                <td v-if="row.goodsReceiptDate">{{ row.goodsReceiptDate | formatDate }}</td>
                <td v-else>{{ $t("wms.inventoryOverviewTooltip.notAvailable") }}</td>
                <td>{{ row.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </hover-popover>
</template>

<script>
import HoverPopover from "@/components/HoverPopover.vue";

export default {
  name: "InventoryDetailTooltip",
  components: { HoverPopover },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    canOpen: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Number],
      default: "-",
    },
  },
  methods: {
    emitOpen() {
      if (!this.canOpen) {
        return;
      }
      this.$emit("open");
    },
  },
};
</script>

<style scoped>
.inventory-hover-target {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: default;
}

.inventory-hover-target--active {
  border-bottom: 1px dashed #9e9e9e;
  cursor: default;
}

.inventory-tooltip-content {
  max-width: min(360px, 62vw);
}

.inventory-tooltip-body {
  max-height: none;
  overflow: visible;
}

.inventory-tooltip-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
}

.inventory-tooltip-table th,
.inventory-tooltip-table td {
  padding: 2px 4px;
  font-size: 0.9em;
  white-space: nowrap;
}

.inventory-tooltip-table thead th {
  font-weight: 600;
  border-bottom: 1px solid #d8d8d8;
}

.inventory-tooltip-table tbody td {
  border-bottom: 1px solid #f0f0f0;
}

.inventory-tooltip-table th:nth-child(1),
.inventory-tooltip-table th:nth-child(2),
.inventory-tooltip-table td:nth-child(1),
.inventory-tooltip-table td:nth-child(2) {
  text-align: left;
}

.inventory-tooltip-table th:nth-child(3),
.inventory-tooltip-table td:nth-child(3) {
  text-align: right;
}

.inventory-tooltip-empty {
  margin-top: 4px;
  font-size: 0.78em;
  color: #616161;
}
</style>

<style>
/* Panel haengt am body, daher ungescoped */
.inventory-detail-tooltip.md-tooltip {
  padding: 4px 6px;
}
</style>
